module.exports = __webpack_public_path__ + "img/deliver-img-1-1.05dc1e5c.png";